import axios from "axios";
import { useQuery } from "react-query";
import {configUrl} from "config.js";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";


export default function useGetAllUserCountByClass() {
  const { config, providerId } = useContext(LoginContext);

  return useQuery("userCountByClass", async () => {
    let response = await axios.get(
      `${configUrl.AssessmentServer}/api/Analytics/dashboard/GetUserCountByClass/${providerId}`
    );
    let lables =response.data.lable['$values'];
    let values =response.data.values['$values']

    return{
      lables,values
    };
  });
}
